"use client";

import React, { useMemo } from "react";
import { Button } from "@/components/ui/button";
import { Calendar } from "lucide-react";
import { getDateFields } from "../utils/calendar-utils";
import type { SimpleTableConfig, BaseEntity } from "../types";

interface TableCalendarButtonProps<TData extends BaseEntity> {
  config: SimpleTableConfig<TData>;
  data: TData[];
  onOpen: () => void;
}

export function TableCalendarButton<TData extends BaseEntity>({
  config,
  data,
  onOpen,
}: TableCalendarButtonProps<TData>) {
  const dateFields = useMemo(() => getDateFields(config), [config]);

  // Don't render if no date fields available
  if (dateFields.length === 0) {
    return null;
  }

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={onOpen}
      className="flex items-center gap-2 flex-shrink-0"
      title={`View ${data.length} items in calendar`}
    >
      <Calendar className="h-4 w-4" />
      <span className="hidden sm:inline">Calendar</span>
    </Button>
  );
}
